module.exports = __webpack_public_path__ + "media/images/countryrect/ug-eb3dbfcb48f3b808b139da1559202e2a.svg";